import React from 'react';

import { IBasicStyledProps } from '@notino/react-styleguide-v20';

import { ReactFCV } from '@types';

import { StyledButtonLineSection } from './styled';

export const ButtonsSkeleton: ReactFCV<IBasicStyledProps> = ({ ...rest }) => (
  <StyledButtonLineSection width={'100%'} data-testid="styled-button-line-section" {...rest} />
);
